import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';
import genererAdresse from '@/services/general/genererAdresse';

export const SOUS_TYPE = 'Aucun';

export const TYPE_CLIENT = 'Client';

export const clientInitial = {
  adresse: '',
  nomCommercial: '',
  nomJuridique: '',
  siret: '',
  siren: '',
  ape: '',
  tvaIntracommunautaire: '',
  secteurActiviteId: null,
  telephone: '',
  portable: '',
  email: '',
  siteWeb: '',
  adressePostale: genererAdresse(),
  adresseFacturation: genererAdresse(),
  contacts: [],
  rib: {
    banque: '',
    iban: '',
    bic: '',
    titulaire: '',
  },
  modeReglementId: null,
  modeReglement: {
    libelle: '',
  },
  delaiReglementId: null,
  delaiReglement: {
    libelle: '',
    delaiReglementDetail: {
      nombreJourDecalage: null,
      finDeMois: false,
      jourFinDeMois: null,
    },
    estPersonnalisable: false,
  },
  delaiReglementDetail: {
    nombreJourDecalage: null,
    finDeMois: false,
    jourFinDeMois: null,
  },
  compteComptable: '',
  commentairesBonDeCommandes: '',
  commentairesFacturation: '',
  commentairesInternes: '',
  piecesJointes: [],
  adresseFacturationDifferente: false,
  archive: false,
  nombreJourDecalage: null,
  finDeMois: null,
  jourFinDeMois: null,
  companyId: 0,
  type: TYPE_CLIENT,
  typologie: 'Aucun',
  tiersParentId: null,
  code: 0,
  marque: '',
  factureParMail: false,
  modeCalculHonoraire: genererModeCalculHonoraire(),
  prospect: true,
  sousTypes: [SOUS_TYPE],
  tiersMarques: [],
  lieuStockage: false,
};




// WEBPACK FOOTER //
// ./src/configuration/clientConf.js